import { Injectable } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CommonService } from './common.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TokenRefreshService {
  private subscription: Subscription;

  constructor(
    private commonService: CommonService,
    public jwt: JwtHelperService,
  ) {}

  private async checkAndRefreshToken() {
    try {
      const accessToken = this.commonService.GetAccessTokenDecrypt();
      const isTokenExpired = this.jwt.isTokenExpired(
        accessToken,
        environment.tokens.accessToken.expirationOffset,
      );

      if (isTokenExpired) {
        console.log('Access token is about to expire. Refreshing...');
        const session = await this.commonService.getCurrentAuthSession(true);
        this.commonService.setCurrentAuthSession(session);
      }
    } catch (error) {
      console.error('Error during access token refresh:', error);
    }
  }

  async startTokenRefresh() {
    // Start a periodic check using RxJS interval. First check will be immediate.
    this.subscription = interval(
      environment.tokens.accessToken.refreshInterval * 1000,
    ).subscribe(async () => {
      await this.checkAndRefreshToken();
    });
    await this.checkAndRefreshToken();
  }

  stopTokenRefresh() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
